module.exports = __webpack_public_path__ + "static/media/style.addb0d47.less";